import type { GicsLevel } from "./types";

export interface GicsLevelConfig {
  label: string;
  badge: string;
  bgClass: string;
  textClass: string;
}

export const GICS_LEVEL_CONFIG: Record<GicsLevel, GicsLevelConfig> = {
  1: {
    label: "Sector",
    badge: "L1",
    bgClass: "bg-purple-100 dark:bg-purple-900/30",
    textClass: "text-purple-700 dark:text-purple-300",
  },
  2: {
    label: "Industry Group",
    badge: "L2",
    bgClass: "bg-blue-100 dark:bg-blue-900/30",
    textClass: "text-blue-700 dark:text-blue-300",
  },
  3: {
    label: "Industry",
    badge: "L3",
    bgClass: "bg-teal-100 dark:bg-teal-900/30",
    textClass: "text-teal-700 dark:text-teal-300",
  },
  4: {
    label: "Sub-Industry",
    badge: "L4",
    bgClass: "bg-green-100 dark:bg-green-900/30",
    textClass: "text-green-700 dark:text-green-300",
  },
};
